/**
 * 节点类型注册
 */
import { ImageDisplayNode } from './ImageDisplayNode';
import { ImageReferenceNode } from './ImageReferenceNode';
import { ImageTaskNode } from './ImageTaskNode';
import { PromptInputNode } from './PromptInputNode';
import { ReferenceToImageNode } from './ReferenceToImageNode';
import { TextToImageNode } from './TextToImageNode';
import { Sora2VideoNode } from './Sora2VideoNode';
import { Veo3VideoNode } from './Veo3VideoNode';
import { DoubaoVideoNode } from './DoubaoVideoNode';
import { Hailuo23VideoNode } from './Hailuo23VideoNode';
import { KlingVideoNode } from './KlingVideoNode';
import { VideoTaskNode } from './VideoTaskNode';
import { VideoReferenceNode } from './VideoReferenceNode';
import { AudioReferenceNode } from './AudioReferenceNode';
import { DrawingNode } from './DrawingNode';
import { NoteNode } from './NoteNode';
import { VideoFaceSwapNode } from './VideoFaceSwapNode';
import { KlingLipSyncNode } from './KlingLipSyncNode';
import { TextToAudioNode } from './TextToAudioNode';
import { AudioTaskNode } from './AudioTaskNode';
import { HailuoMusicNode } from './HailuoMusicNode';
import { MinimaxImageNode } from './MinimaxImageNode';
import { GoogleBananaNode } from './GoogleBananaNode';
import { BananaProNode } from './BananaProNode';
import { ImengImageGenNode } from './ImengImageGenNode';
import { VideoAudioMergeNode } from './VideoAudioMergeNode';
import { AudioTrimNode } from './AudioTrimNode';
import { SoraRoleCreateNode } from './SoraRoleCreateNode';
import { SunoMusicNode } from './SunoMusicNode';
import { GptImage2Node } from './GptImage2Node';
import { NanoBanana2Node } from './NanoBanana2Node';
import { MinimaxH3VideoNode } from './MinimaxH3VideoNode';
import { KlingO3ReferenceVideoNode } from './KlingO3ReferenceVideoNode';
import { GeminiOmniFlashVideoNode } from './GeminiOmniFlashVideoNode';
import { SuperSeed2LiteVideoNode } from './SuperSeed2LiteVideoNode';

export const nodeTypes = {
  imageDisplay: ImageDisplayNode,
  imageReference: ImageReferenceNode,
  imageTask: ImageTaskNode,
  promptInput: PromptInputNode,
  referenceToImage: ReferenceToImageNode,
  textToImage: TextToImageNode,
  sora2Video: Sora2VideoNode,
  veo3Video: Veo3VideoNode,
  doubaoVideo: DoubaoVideoNode,
  hailuo23Video: Hailuo23VideoNode,
  klingVideo: KlingVideoNode,
  videoTask: VideoTaskNode,
  videoReference: VideoReferenceNode,
  audioReference: AudioReferenceNode,
  drawing: DrawingNode,
  note: NoteNode,
  videoFaceSwap: VideoFaceSwapNode,
  klingLipSync: KlingLipSyncNode,
  textToAudio: TextToAudioNode,
  audioTask: AudioTaskNode,
  hailuoMusic: HailuoMusicNode,
  minimaxImage: MinimaxImageNode,
  googleBanana: GoogleBananaNode,
  bananaPro: BananaProNode,
  imengImageGen: ImengImageGenNode,
  videoAudioMerge: VideoAudioMergeNode,
  audioTrim: AudioTrimNode,
  soraRoleCreate: SoraRoleCreateNode,
  sunoMusic: SunoMusicNode,
  gptImage2: GptImage2Node,
  nanoBanana2: NanoBanana2Node,
  minimaxH3Video: MinimaxH3VideoNode,
  klingO3ReferenceVideo: KlingO3ReferenceVideoNode,
  geminiOmniFlashVideo: GeminiOmniFlashVideoNode,
  superSeed2LiteVideo: SuperSeed2LiteVideoNode,
};
